import { useWindowSize } from "react-use";
import styled from "styled-components";
import { SectionContainer, SectionTitle } from "screens/Homepage/styles";
import { defaultTheme as theme } from "@beamcloud/design-system";
import AllPlansTable from "./AllPlansTable";
import IndividualPlanTable from "../_components/IndividualPlanTable";

const Plans: React.FC = () => {
  const { width } = useWindowSize();

  return (
    <SectionContainer>
      <TitleWrapper>
        <SectionTitle>Pricing Plans</SectionTitle>
      </TitleWrapper>
      {width >= theme.breakpoints.lg ? <AllPlansTable /> : <IndividualPlanTable />}
    </SectionContainer>
  );
};

export default Plans;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  padding: 0px;
  gap: 24px;
`;
